import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import ExternalLink from '@toasttab/shared/src/components/molecules/ExternalLink/ExternalLink'
import Header from '@toasttab/shared/src/components/organisms/Header/Header'
import Footer from '@toasttab/shared/src/components/organisms/Footer/Footer'
import { initDataCapture } from '@toasttab/shared/src/hooks/useDataCapture'
import { usePageContext } from '../hooks/usePageContext'
import { MainLayoutProps } from './MainLayout.d'

const MainLayout = ({
  children,
  currentLanguage,
  footerContent,
  localizedEntries,
  mobileSalesIndicatorSchedule,
  packageName,
  siteId,
  siteMetadata
}: MainLayoutProps) => {
  const [showMobileStickyCTA, setShowMobileStickyCTA] = useState(true)
  const [mainClasses, setMainClasses] = useState('')
  const {
    activeGlobalBanner,
    headerStyle = 'Default',
    isRegionBannerActive,
    styleContext
  } = usePageContext()

  useEffect(() => {
    initDataCapture()
  }, [])

  useEffect(() => {
    // Hard-coding override to disable sticky CTA for new Fall Release 2024 page and local restaurant sales comparison, need a contentmodel change for this probably
    if (
      typeof window !== 'undefined' &&
      (window.location.pathname === '/innovation-hub/fall-2024' ||
        window.location.pathname === '/local-restaurant-sales-comparison')
    ) {
      setShowMobileStickyCTA(false)
    }
  }, [])

  useEffect(() => {
    // Some blog pages use MDS MainLayout, so we need to account for styling here
    const isBlog =
      typeof window !== 'undefined' &&
      window.location.pathname.includes('/blog/')

    setMainClasses(
      classNames({
        'main-layout': !isBlog,
        'otl-entry-container': isBlog,
        'mt-6': !isBlog && !isRegionBannerActive && activeGlobalBanner,
        'pt-40 md:pt-28': isBlog && !isRegionBannerActive && activeGlobalBanner,
        'mt-60 md:mt-36': isRegionBannerActive && activeGlobalBanner,
        'mt-40 md:mt-28': isRegionBannerActive && !activeGlobalBanner
      })
    )
  }, [activeGlobalBanner, isRegionBannerActive])

  const layoutClasses = classNames({
    'pt-20':
      headerStyle !== 'Logo Only' &&
      !activeGlobalBanner &&
      !isRegionBannerActive &&
      styleContext !== 'request-demo' &&
      styleContext !== 'hpVariant',
    'pt-[6.5rem]':
      headerStyle !== 'Logo Only' &&
      (activeGlobalBanner || isRegionBannerActive) &&
      styleContext !== 'request-demo' &&
      styleContext !== 'hpVariant-demo',
    'pt-14 lg:pt-20': styleContext === 'request-demo',
    'pt-16 lg:pt-20': styleContext === 'hpVariant'
  })

  return (
    <div className={layoutClasses}>
      <Header
        enabledMobileStickyCTA={showMobileStickyCTA}
        mobileSalesIndicatorSchedule={mobileSalesIndicatorSchedule}
        packageName={packageName}
        siteId={siteId}
        siteMetadata={siteMetadata}
        localizedEntries={localizedEntries}
      />
      <main className={mainClasses}>{children}</main>
      <Footer
        currentLanguage={currentLanguage}
        footerContent={footerContent}
        hostName={siteMetadata?.hostName}
        localizedEntries={localizedEntries}
        packageName={packageName}
        siteId={siteId}
        siteMetadata={siteMetadata}
      />
      <ExternalLink />
    </div>
  )
}

export default MainLayout
